var map = {
	"./ahmedabad.png": 9094,
	"./bengaluru.png": 1887,
	"./chennai.png": 8318,
	"./delhi.png": 8018,
	"./hyderabad.png": 8671,
	"./jaipur.png": 6453,
	"./kolkata.png": 6555,
	"./lucknow.png": 9756,
	"./mumbai.png": 838,
	"./pune.png": 6255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2235;